<div class="adios-button" [ngClass]="highlight" [class.margin-top-20]="addmargin">
    <div class="button-arrow">
        <div class="btn-highlight" [ngClass]="highlight"></div>
        <img src="../../../../assets/images/icons/right-arrow.svg" alt="arrow" class="arrow">
    </div>
    <ng-content></ng-content>
</div>
